let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7k8Ro"), load("hGXAt"), load("ct3kN"), load("c6MKV"), load("aZinD"), load("4Pn6Z"), load("8sv0D")]).then(() => parcelRequire('awg6S'));